if (!customElements.get('media-gallery')) { 
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {

    constructor() {
      super();
      this.slider = this.querySelector('[id^="images-slider-"]');
      this.thumbnails = this.querySelector('.thumbnails-slider');
      this.dots = this.querySelector('[id^="GalleryThumbnails-dots"]');
      this.only_mobile_dots = this.querySelector('[data-mobile-thumbs]');
            

      if(!this.slider) return

      
      this.is_slider = this.slider.getAttribute("data-desktop-type") === "slider";
      this._selected = this.slider.querySelector('[data-selected]');
      this.autoheight = this.dataset.autoheight === "true";
      this.isLargeScreen = window.innerWidth > 850;      


      // Set initial selected
      this.handleSelected();




      document.addEventListener('DOMContentLoaded', () => this.updateThumbnailsHeight());
      window.addEventListener('resize', () => this.updateThumbnailsHeight());

      const debouncedResize = debounce(this.handleSelected.bind(this), 250);
      window.addEventListener('resize', debouncedResize);



      if ('onscrollend' in window) {
        this.slider.addEventListener('scrollend', () => this.handleSelected());
      } else {
        let timer;
        this.slider.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.handleSelected(), 250);
        });
      }



      [...this.querySelectorAll('.thumbnail')].forEach(thumbnail=>{
        thumbnail.addEventListener('click', ()=>{
          this.updateThumbnail(thumbnail.getAttribute('data-skip'))
          this.sliderScroll(thumbnail.getAttribute('data-skip'))
        })
      })

      if (!this.thumbnails) return;      
      this.isVertical = this.thumbnails.getAttribute('data-inline') === "true";

    }


    handleResize() {
      this.handleHeight()
    }


    onSelectedChange(newValue) {  
      this.slider.dispatchEvent(new CustomEvent('selected:change', {
        detail: { selected: newValue }
      }));
      
    }

    handleSelected(){
        
        const sliderRect = this.slider.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;

        let closestItem = null;
        let minDistance = Infinity;

        [...this.slider.children].forEach((item) => {
          if (!item.dataset.image) return; // Skip if no image data

          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(sliderCenter - itemCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestItem = item;
          }
        });


        if (closestItem) {
          if (this.thumbnails) {
            this.updateThumbnail(closestItem.getAttribute('data-image') * 1);
          }
          // 🔹 Use the unified update method so event & logic stay consistent
          this.updateSelected(closestItem);
          if (this.autoheight) {
            //this.updateHeight(1 * this.selected.dataset.height, 1 * this.selected.dataset.width);
            this.handleHeight(closestItem)
          }
          

          // Optionally: auto height adjustment or any follow-up logic
          /* if (this.autoheight && (this.is_slider || window.innerWidth <= 850)) {
            this.handleHeight();
          } */
        }

    }

    scrollToImage(selected){
          if (this.is_slider || window.innerWidth < 850) {
            const slider_x_start = this.slider.getBoundingClientRect().left;
            const selected_x = selected.getBoundingClientRect().left;
            const offset = selected_x - slider_x_start;
        
            this.slider.scrollTo({
            left: this.slider.scrollLeft + offset,
            behavior: 'instant' // 'auto' or remove this line if 'instant' doesn't work well
            });
        } else {
            const element_rect = selected.getBoundingClientRect();
            const scroll_target = window.scrollY + element_rect.top - (window.innerHeight / 2) + (element_rect.height / 2);
        
            window.scrollTo({
            top: scroll_target,
            behavior: "smooth"
            });
        }
    }

    sliderScroll(index){              
          const selected_element = this.slider.querySelector(`[data-image='${index}']`);
          if (!selected_element) return;

          this.scrollToImage(selected_element);

    }

    updateSelected(newElement) {
      if (!newElement) return;
      if (this.selected) this.selected.removeAttribute('data-selected');
      newElement.setAttribute('data-selected', 'true');
      this.selected = newElement; // triggers setter and onSelectedChange()
    }

    updateThumbnail(index) {
      if (!this.thumbnails || index === undefined) return;
    
      
      const thumbnails = this.thumbnails.querySelectorAll('.thumbnail');

      thumbnails.forEach(thumbnail => {
        const isActive = thumbnail.getAttribute('data-skip') * 1 === index * 1;
        thumbnail.setAttribute('aria-pressed', isActive.toString());

        if (isActive) {
          thumbnail.classList.add('active');
          thumbnail.setAttribute('aria-current', 'true');
          if (thumbnail.classList.contains('thumbnail_image')) {
            this.thumbnailScrollImages(thumbnail)
          }
        } else {
          thumbnail.classList.remove('active');
          thumbnail.removeAttribute('aria-current');
        }
      });
    }

    thumbnailScrollImages(thumbnail){
          const container = thumbnail.closest('.product_thumbnails')
          const containerRect = container.getBoundingClientRect();
          
          const thumbnailRect = thumbnail.getBoundingClientRect();          
    
          if (this.isVertical && this.isLargeScreen) {
            // Scroll Vertically if in vertical mode and screen is large
            const containerScrollTop = container.scrollTop;
            const scrollTo = containerScrollTop + (thumbnailRect.top + thumbnailRect.height / 2) - 
                             (containerRect.top + containerRect.height / 2);
            container.scrollTo({ top: scrollTo, behavior: 'smooth' });
          } else {

            
            // Scroll Horizontally (default for small screens or horizontal mode)
            const containerScrollLeft = container.scrollLeft;
            const scrollTo = containerScrollLeft + (thumbnailRect.left + thumbnailRect.width / 2) - 
                             (containerRect.left + containerRect.width / 2);
            container.scrollTo({ left: scrollTo, behavior: 'smooth' });
          }
    }

    updateThumbnailsHeight() {
      
      if (!this.slider || !this.thumbnails) return;
       
        const thumbnail_images = this.thumbnails.querySelector('[id^="GalleryThumbnails-images-"]')


        if (thumbnail_images) {
          const isVertical = this.thumbnails.getAttribute('data-inline') === "true";
          const isLargeScreen = window.innerWidth > 850;
        
          if (!isVertical || !isLargeScreen) {
            // Reset height if it's horizontal or on a small screen
            thumbnail_images.style.maxHeight = "";
            return;
          }
        
          const sliderHeight = this.slider.clientHeight;
          thumbnail_images.style.maxHeight = `${sliderHeight}px`;
        }
    
      
    }

    handleHeight(){
 
      if (this.is_slider || window.innerWidth < 850) {        
        if (this.autoheight && this.selected) {
          return  this.slider.style.height = `${ this.selected.offsetWidth * this.selected.dataset.height / this.selected.dataset.width }px`;
        }else {
          return  this.slider.style.height = "auto" 
        }
        
      }else{
        return  this.slider.style.height = "auto"
      }
    }

    get selected() {
      return this._selected;
    }

    set selected(newValue) {                  
      if (this._selected !== newValue) {
        this._selected = newValue;
        this.onSelectedChange(newValue);
      }
    }

  });
}
